;(function() {
  'use strict'

  Controller.$inject = ["$state", "uacService", "cloudinaryService"];
  angular.module('app.core').component('projectItem', {
    controller: Controller,
    templateUrl: 'project-item.html',
    bindings: {
      project: '<',
      layout: '@',
      variant: '@',
      link: '<',
      onClick: '&?',
      onArchive: '&',
      onUnarchive: '&',
    },
  })

  /* @ngInject */
  function Controller($state, uacService, cloudinaryService) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.$onChanges = onChanges
    ctrl.getMenuItems = getMenuItems

    function onInit() {
      ctrl.canManage = uacService.canManageProjects()
      ctrl.canArchive = ctrl.isProjects && ctrl.canManage
    }

    function onChanges() {
      ctrl.isProjects = ctrl.variant === 'projects'
      ctrl.isRow = ctrl.layout === 'row'

      ctrl.info = ctrl.project.getCountsLabel()
      ctrl.isLink = ctrl.isProjects || !!ctrl.link
      ctrl.href = ctrl.isLink
        ? $state.href('project', { id: ctrl.project.id })
        : null

      var imageUrl = cloudinaryService.resize(
        ctrl.project.imageUrl,
        ctrl.isRow ? 160 : 400
      )
      ctrl.imageStyle = imageUrl && {
        backgroundImage: 'url(' + imageUrl + ')',
      }
    }

    function getMenuItems() {
      if (!ctrl.canArchive) return []
      return [
        ctrl.project.isArchived
          ? { text: 'Unarchive', onClick: ctrl.onUnarchive, last: true }
          : {
              text: 'Archive',
              onClick: ctrl.onArchive,
              last: true,
              danger: true,
            },
      ]
    }
  }
})()
